import 'regenerator-runtime/runtime'

import AppConfig from '@/configs/app.config.js'
import AuthService from '@/services/authService'
import router from '@/router'
import store from '@/store'

class Auth {

  /**
   * บันทึก cookie การเข้าสู่ระบบ
   * @param  {Object} data {token: '', refreshToken: ''}
   * @return {Boolean}      Promise
   */
  async saveLogin(data) {
    const { token, refreshToken } = data
    await localStorage.setItem(AppConfig.key.LoggedIn, true)
    await localStorage.setItem(AppConfig.key.RefreshTokenKey, refreshToken)
    await localStorage.setItem(AppConfig.key.TokenKey, token)
    return true
  }

  /**
   * ออกจากระบบ frontend และส่งไปหน้า login
   */
  logout() {
    AuthService.logout()
    .then(async (response)=>{
      console.log(response)
    })
    .finally(async ()=>{
      await localStorage.removeItem(AppConfig.key.LoggedIn)
      await localStorage.removeItem(AppConfig.key.RefreshTokenKey)
      await localStorage.removeItem(AppConfig.key.TokenKey)
      store.commit('resetNews', true)
      router.push({name: 'Login'})
    })
  }

  /**
   * token ที่เก็บไว้ frontend มาติดต่อกับ backend
   * @return {[String]} token or null
   */
  async getToken() {
    try {
      return localStorage.getItem(AppConfig.key.TokenKey)
    }
    catch(e) {
      console.log(e)
      return null
    }
  }

}

export default new Auth()
